// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z28I","badges":"styles_badges__2n1nM"};